// /* =========================================================
//    Wear The House – Landing Page A (Waitlist) – shared script
//    Countdown · local time · smooth scroll · email forms · sticky bar
//    ========================================================= */
// (function () {
//   if (window.__wthLpInit) return;
//   window.__wthLpInit = true;

//   var DESIGN_MODE = !!(window.Shopify && window.Shopify.designMode);
//   var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
//   var POSTED_KEY = 'wthLpFormPosted';

//   function cfg() { return window.WTH_LP || {}; }
//   function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
//   function pad(n) { return (n < 10 ? '0' : '') + n; }

//   /* ---------- launch time ---------- */
//   function launchTs() {
//     var t = Date.parse(cfg().launch || '2026-11-11T11:11:00-08:00');
//     return isNaN(t) ? null : t;
//   }

//   function renderLocalTime() {
//     var t = launchTs();
//     if (!t) return;
//     var txt;
//     try {
//       txt = new Intl.DateTimeFormat(undefined, { weekday: 'short', hour: 'numeric', minute: '2-digit' }).format(new Date(t));
//     } catch (e) { txt = new Date(t).toLocaleString(); }
//     $all('[data-lp-local]').forEach(function (el) { el.textContent = txt; });
//   }

//   function tick() {
//     var t = launchTs();
//     if (!t) return;
//     var diff = Math.max(0, t - Date.now());
//     var s = Math.floor(diff / 1000);
//     var d = Math.floor(s / 86400), h = Math.floor((s % 86400) / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
//     $all('[data-lp-cd]').forEach(function (el) {
//       var k = el.getAttribute('data-lp-cd');
//       el.textContent = k === 'd' ? pad(d) : k === 'h' ? pad(h) : k === 'm' ? pad(m) : pad(sec);
//     });
//     $all('[data-lp-opens]').forEach(function (el) { el.textContent = d + 'd ' + pad(h) + 'h ' + pad(m) + 'm'; });
//     document.documentElement.classList.toggle('lp-launched', diff <= 0);
//   }

//   /* ---------- smooth scroll to the waitlist form ---------- */
//   function topOffset() {
//     var bar = document.querySelector('[data-lp-countdown]');
//     return (bar ? bar.offsetHeight : 0) + 16;
//   }
//   function scrollToWaitlist() {
//     var target = document.getElementById('lp-waitlist') || document.querySelector('[data-lp-form]');
//     if (!target) return false;
//     var y = target.getBoundingClientRect().top + window.pageYOffset - topOffset();
//     window.scrollTo({ top: y, behavior: 'smooth' });
//     var input = target.querySelector('input[type="email"]');
//     if (input) setTimeout(function () { try { input.focus({ preventScroll: true }); } catch (e) { input.focus(); } }, 700);
//     return true;
//   }
//   document.addEventListener('click', function (e) {
//     var trigger = e.target.closest('[data-lp-scroll]');
//     if (!trigger) return;
//     if (scrollToWaitlist()) e.preventDefault();
//   });

//   /* ---------- email forms ---------- */
//   function setState(wrap, state, msg) {
//     wrap.classList.remove('is-error', 'is-loading');
//     if (state) wrap.classList.add('is-' + state);
//     var m = wrap.querySelector('[data-lp-msg]');
//     if (m) m.textContent = msg || '';
//   }
//   function setSuccess(wrap) {
//     clearTimeout(wrap._lpTimer);
//     setState(wrap, null);
//     wrap.classList.add('is-success');
//     document.documentElement.classList.add('lp-subscribed');
//     updateSticky();
//   }
//   function setError(wrap, msg) {
//     clearTimeout(wrap._lpTimer);
//     setState(wrap, 'error', msg || cfg().errorGeneric || 'Something went wrong. Please try again.');
//   }
//   function resetCaptcha(form) {
//     $all('[name="h-captcha-response"],[name="g-recaptcha-response"]', form).forEach(function (i) { i.value = ''; });
//     try { if (window.hcaptcha && window.hcaptcha.reset) window.hcaptcha.reset(); } catch (e) {}
//   }

//   /* Same Shopify customer form as the homepage popup (same tags + Shopify spam check),
//      sent in the background so the visitor stays on the page */
//   function ajaxSubmit(form, wrap) {
//     if (wrap._lpSending) return;
//     wrap._lpSending = true;
//     var body = new URLSearchParams(new FormData(form));
//     fetch(form.getAttribute('action').split('#')[0], {
//       method: 'POST',
//       body: body,
//       credentials: 'same-origin',
//       headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'text/html' }
//     }).then(function (r) {
//       var url = r.url || '';
//       console.log('[LP form]', form.id, r.status, url);
//       if (/customer_posted=true/.test(url)) { setSuccess(wrap); return; }
//       if (url.indexOf('/challenge') > -1) {
//         /* Shopify wants this visitor to do its "I am human" check – same as the popup */
//         try { sessionStorage.setItem(POSTED_KEY, wrap.id); } catch (e) {}
//         form.removeAttribute('target');
//         HTMLFormElement.prototype.submit.call(form);
//         return;
//       }
//       return r.text().then(function (html) {
//         if (/captcha/i.test(html)) { resetCaptcha(form); setError(wrap); return; }
//         if (!r.ok || /\/contact$/.test(url.split('?')[0].split('#')[0])) {
//           var m = html.match(/class="[^"]*errors[^"]*"[^>]*>([\s\S]*?)<\//);
//           setError(wrap, m ? m[1].replace(/<[^>]+>/g, '').trim() : '');
//           return;
//         }
//         setSuccess(wrap);
//       });
//     }).catch(function (err) {
//       console.warn('[LP form]', err);
//       setError(wrap);
//     }).then(function () { wrap._lpSending = false; });
//   }

//     function warmForm(form) {
//     var i = form.querySelector('input[type="email"]');
//     if (!i) return;
//     try {
//       i.dispatchEvent(new FocusEvent('focusin', { bubbles: true }));
//       i.dispatchEvent(new FocusEvent('focus'));
//     } catch (e) {}
//   }

//   function setupForms() {
//     $all('[data-lp-form] form').forEach(function (form) {
//       var wrap = form.closest('[data-lp-form]');
//       form.noValidate = true;
//       form.removeAttribute('target');
//       /* Shopify's spam check calls form.submit() after it adds its token – send it in the background instead */
//       form.submit = function () { ajaxSubmit(form, wrap); };
//       /* load Shopify's spam check as soon as the visitor touches the form */
//       var warmed = false;
//       ['pointerdown', 'touchstart', 'keydown'].forEach(function (ev) {
//         wrap.addEventListener(ev, function () { if (!warmed) { warmed = true; warmForm(form); } }, { passive: true });
//       });
//     });
//     /* and quietly after the page has loaded */
//     window.addEventListener('load', function () {
//       setTimeout(function () { $all('[data-lp-form] form').forEach(warmForm); }, 2500);
//     });
//   }

//   /* 1) first: check the email */
//   document.addEventListener('submit', function (e) {
//     var form = e.target;
//     var wrap = form.closest && form.closest('[data-lp-form]');
//     if (!wrap) return;
//     var input = wrap.querySelector('input[type="email"]');
//     var email = (input && input.value || '').trim();
//     if (!EMAIL_RE.test(email)) {
//       e.preventDefault();
//       e.stopImmediatePropagation();
//       setError(wrap, cfg().errorEmail || 'Please enter a valid email address.');
//       if (input) input.focus();
//       return;
//     }
//     setState(wrap, 'loading');
//     clearTimeout(wrap._lpTimer);
//     wrap._lpTimer = setTimeout(function () {
//       if (wrap.classList.contains('is-loading')) setState(wrap, null);
//     }, 20000);
//   }, true);

//    /* 2) last: if Shopify's spam check didn't take over, send it in the background ourselves */
//   window.addEventListener('submit', function (e) {
//     var form = e.target;
//     var wrap = form.closest && form.closest('[data-lp-form]');
//     if (!wrap || e.defaultPrevented) return;
//     e.preventDefault();
//     var hasToken = $all('[name="h-captcha-response"]', form).some(function (i) { return i.value; });
//     /* spam check not ready yet (fast tap on mobile): load it, wait a moment, send automatically */
//     if (!hasToken && !form.dataset.hcaptchaBound && !wrap._lpWaited) {
//       wrap._lpWaited = true;
//       warmForm(form);
//       setTimeout(function () {
//         if (form.requestSubmit) form.requestSubmit(); else ajaxSubmit(form, wrap);
//       }, 1500);
//       return;
//     }
//     wrap._lpWaited = false;
//     ajaxSubmit(form, wrap);
//   });

//   /* after Shopify's "I am human" page, show the result on the form that was used */
//   function restorePosted() {
//     var id;
//     try { id = sessionStorage.getItem(POSTED_KEY); sessionStorage.removeItem(POSTED_KEY); } catch (e) {}
//     if (!id) return;
//     var wrap = document.getElementById(id);
//     if (!wrap) return;
//     if (/[?&]customer_posted=true/.test(window.location.search)) setSuccess(wrap);
//     var y = wrap.getBoundingClientRect().top + window.pageYOffset - topOffset() - 120;
//     window.scrollTo(0, Math.max(0, y));
//   }

//   /* ---------- sticky bottom bar ---------- */
//   var sticky, heroPassed = false, zonesInView = [];
//   function updateSticky() {
//     if (!sticky) return;
//     var show = heroPassed && zonesInView.length === 0 && !document.documentElement.classList.contains('lp-subscribed');
//     sticky.classList.toggle('is-visible', show);
//     sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
//   }
//   function initSticky() {
//     sticky = document.querySelector('[data-lp-sticky]');
//     if (!sticky || !('IntersectionObserver' in window)) return;
//     if (!DESIGN_MODE) document.body.appendChild(sticky);
//     var hero = document.querySelector('[data-lp-hero-form]');
//     var forms = $all('[data-lp-zone] [data-lp-form]');
//     if (!hero) heroPassed = true;
//     if (hero) {
//       new IntersectionObserver(function (entries) {
//         entries.forEach(function (en) { heroPassed = !en.isIntersecting && en.boundingClientRect.top < 0; });
//         updateSticky();
//       }, { threshold: 0 }).observe(hero);
//     }
//     var io = new IntersectionObserver(function (entries) {
//       entries.forEach(function (en) {
//         var i = zonesInView.indexOf(en.target);
//         if (en.isIntersecting && i === -1) zonesInView.push(en.target);
//         if (!en.isIntersecting && i > -1) zonesInView.splice(i, 1);
//       });
//       updateSticky();
//     }, { threshold: 0, rootMargin: '-10% 0px -10% 0px' });
//     forms.forEach(function (f) { io.observe(f); });
//   }

//   /* ---------- countdown bar to the very top ---------- */
//   function initCountdownBar() {
//     var bar = document.querySelector('[data-lp-countdown]');
//     if (!bar || DESIGN_MODE) return;
//     document.body.insertBefore(bar, document.body.firstChild);
//     bar.classList.add('lp-cd--fixed');
//     function setOffset() { document.body.style.paddingTop = bar.offsetHeight + 'px'; }
//     setOffset();
//     window.addEventListener('resize', setOffset);
//     window.addEventListener('load', setOffset);
//     if ('ResizeObserver' in window) new ResizeObserver(setOffset).observe(bar);
//   }

//   function init() {
//     setupForms();
//     initCountdownBar();
//     renderLocalTime();
//     tick();
//     setInterval(tick, 1000);
//     restorePosted();
//     initSticky();
//   }
//   if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
//   else init();

//   /* theme editor: refresh when sections are re-rendered */
//   document.addEventListener('shopify:section:load', function () { renderLocalTime(); tick(); });
// })();

/* =========================================================
   Wear The House – Landing Page A (Waitlist) – shared script
   Countdown · local time · smooth scroll · email forms · sticky bar
   ========================================================= */
(function () {
  if (window.__wthLpInit) return;
  window.__wthLpInit = true;

  var DESIGN_MODE = !!(window.Shopify && window.Shopify.designMode);
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  var KLAVIYO_COMPANY = 'X3ehmP';   /* Klaviyo public key */
  var KLAVIYO_LIST = 'SqnqgU';      /* WTH Waitlist */

  function cfg() { return window.WTH_LP || {}; }
  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  /* ---------- launch time ---------- */
  function launchTs() {
    var t = Date.parse(cfg().launch || '2026-11-11T11:11:00-08:00');
    return isNaN(t) ? null : t;
  }
  function renderLocalTime() {
    var t = launchTs();
    if (!t) return;
    var txt;
    try {
      txt = new Intl.DateTimeFormat(undefined, { weekday: 'short', hour: 'numeric', minute: '2-digit' }).format(new Date(t));
    } catch (e) { txt = new Date(t).toLocaleString(); }
    $all('[data-lp-local]').forEach(function (el) { el.textContent = txt; });
  }
  function tick() {
    var t = launchTs();
    if (!t) return;
    var diff = Math.max(0, t - Date.now());
    var s = Math.floor(diff / 1000);
    var d = Math.floor(s / 86400), h = Math.floor((s % 86400) / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
    $all('[data-lp-cd]').forEach(function (el) {
      var k = el.getAttribute('data-lp-cd');
      el.textContent = k === 'd' ? pad(d) : k === 'h' ? pad(h) : k === 'm' ? pad(m) : pad(sec);
    });
    $all('[data-lp-opens]').forEach(function (el) { el.textContent = d + 'd ' + pad(h) + 'h ' + pad(m) + 'm'; });
    document.documentElement.classList.toggle('lp-launched', diff <= 0);
  }

  /* ---------- smooth scroll to the waitlist form ---------- */
  function topOffset() {
    var bar = document.querySelector('[data-lp-countdown]');
    return (bar ? bar.offsetHeight : 0) + 16;
  }
  function scrollToWaitlist() {
    var target = document.getElementById('lp-waitlist') || document.querySelector('[data-lp-form]');
    if (!target) return false;
    var y = target.getBoundingClientRect().top + window.pageYOffset - topOffset();
    window.scrollTo({ top: y, behavior: 'smooth' });
    var input = target.querySelector('input[type="email"]');
    if (input) setTimeout(function () { try { input.focus({ preventScroll: true }); } catch (e) { input.focus(); } }, 700);
    return true;
  }
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-lp-scroll]');
    if (!trigger) return;
    if (scrollToWaitlist()) e.preventDefault();
  });

  /* ---------- email forms: straight to Klaviyo WTH Waitlist ---------- */
  function setState(wrap, state, msg) {
    wrap.classList.remove('is-error', 'is-loading');
    if (state) wrap.classList.add('is-' + state);
    var m = wrap.querySelector('[data-lp-msg]');
    if (m) m.textContent = msg || '';
  }
  function setSuccess(wrap) {
    setState(wrap, null);
    wrap.classList.add('is-success');
    document.documentElement.classList.add('lp-subscribed');
    updateSticky();
  }
  function utmSource() {
    try {
      var p = new URLSearchParams(window.location.search);
      return p.get('utm_source') || '';
    } catch (e) { return ''; }
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    var wrap = form.closest && form.closest('[data-lp-form]');
    if (!wrap) return;
    e.preventDefault();
    e.stopImmediatePropagation();

    var input = wrap.querySelector('input[type="email"]');
    var email = (input && input.value || '').trim();
    if (!EMAIL_RE.test(email)) {
      setState(wrap, 'error', cfg().errorEmail || 'Please enter a valid email address.');
      if (input) input.focus();
      return;
    }
    setState(wrap, 'loading');

    fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(KLAVIYO_COMPANY), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', 'Accept': 'application/vnd.api+json', 'revision': '2024-10-15' },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'WTH Waitlist – ' + ((cfg().isHome && wrap.hasAttribute('data-lp-hero-form')) ? 'Homepage hero' : (wrap.getAttribute('data-lp-form-name') || 'site')),
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  properties: { waitlist_page: window.location.pathname, waitlist_utm_source: utmSource() }
                }
              }
            }
          },
          relationships: { list: { data: { type: 'list', id: KLAVIYO_LIST } } }
        }
      })
    }).then(function (r) {
      if (!r.ok) throw new Error('Klaviyo ' + r.status);
      setSuccess(wrap);
    }).catch(function (err) {
      console.warn('[LP form]', err);
      setState(wrap, 'error', cfg().errorGeneric || 'Something went wrong. Please try again.');
    });
  }, true);

  /* ---------- sticky bottom bar ---------- */
  var sticky, heroPassed = false, zonesInView = [];
  function updateSticky() {
    if (!sticky) return;
    var show = heroPassed && zonesInView.length === 0 && !document.documentElement.classList.contains('lp-subscribed');
    sticky.classList.toggle('is-visible', show);
    sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
  }
  function initSticky() {
    sticky = document.querySelector('[data-lp-sticky]');
    if (!sticky || !('IntersectionObserver' in window)) return;
    if (!DESIGN_MODE) document.body.appendChild(sticky);
    var hero = document.querySelector('[data-lp-hero-form]');
    var forms = $all('[data-lp-zone] [data-lp-form]');
    if (!hero) heroPassed = true;
    if (hero) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { heroPassed = !en.isIntersecting && en.boundingClientRect.top < 0; });
        updateSticky();
      }, { threshold: 0 }).observe(hero);
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var i = zonesInView.indexOf(en.target);
        if (en.isIntersecting && i === -1) zonesInView.push(en.target);
        if (!en.isIntersecting && i > -1) zonesInView.splice(i, 1);
      });
      updateSticky();
    }, { threshold: 0, rootMargin: '-10% 0px -10% 0px' });
    forms.forEach(function (f) { io.observe(f); });
  }

  /* ---------- countdown bar to the very top ---------- */
  function initCountdownBar() {
    var bar = document.querySelector('[data-lp-countdown]');
    if (!bar || DESIGN_MODE) return;
    document.body.insertBefore(bar, document.body.firstChild);
    bar.classList.add('lp-cd--fixed');
    function setOffset() { document.body.style.paddingTop = bar.offsetHeight + 'px'; }
    setOffset();
    window.addEventListener('resize', setOffset);
    window.addEventListener('load', setOffset);
    if ('ResizeObserver' in window) new ResizeObserver(setOffset).observe(bar);
  }

  function init() {
    $all('[data-lp-form] form').forEach(function (f) { f.noValidate = true; });
    initCountdownBar();
    renderLocalTime();
    tick();
    setInterval(tick, 1000);
    initSticky();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', function () { renderLocalTime(); tick(); });
})();